import { useContext } from "react";
import { shouldShowRoundingDisclosure } from "@common/helpers/excel-presentation";
import {
    ROUNDING_FOOTNOTE_TEXT,
    buildScaleDisclosureText,
} from "@common/helpers/sheet";
import { AccountingReportContext } from "./AccountingReport.context";

// Reads context, not the react-query hook, so these only fire for reports that
// resolve a format through the provider. Both reuse the XLSX export's gate and
// text so the in-app disclosure never diverges from the workbook.
export function useAmountScaleCaption(): string | undefined {
    const { numberFormat } = useContext(AccountingReportContext);
    if (!numberFormat) {
        return undefined;
    }
    const scale = buildScaleDisclosureText(numberFormat);
    return scale.length > 0 ? scale : undefined;
}

export function useRoundingFootnote(): string | undefined {
    const { numberFormat } = useContext(AccountingReportContext);
    if (!numberFormat || !shouldShowRoundingDisclosure(numberFormat)) {
        return undefined;
    }
    return ROUNDING_FOOTNOTE_TEXT;
}
